import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.dev';
import { BaseService } from '../../@core/services/base.service';

export enum ToolingAction {
  CONTINUE = 'CONTINUE',
  SUMMARIZE = 'SUMMARIZE',
  TRANSLATE = 'TRANSLATE',
}

@Injectable({
  providedIn: 'root'
})
export class AiToolingService extends BaseService {

  private url = environment.apiUrl + '/ai-tooling';

  constructor(
    protected override http: HttpClient,
    protected ngZone: NgZone
  ) {
    super(http, ngZone);
  }

  runAITooling(data: { query: string; action: ToolingAction; documentId?: string }) {
    return this.post<{ success: boolean }>(this.url + '/run', data);
  }
}
